export const formatPercent = (
  value: number | string,
  digits: number = 1
): string => {
  const num = typeof value === "string" ? Number(value) : value;
  if (!Number.isFinite(num)) return "--%";
  const rounded = Number(num.toFixed(digits));
  if (Number.isInteger(rounded)) {
    return `${Math.trunc(rounded)}%`;
  }
  return `${rounded.toFixed(digits)}%`;
};

export const toFixedNumber = (
  value: number | string,
  digits: number = 1
): number => {
  const num = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(num)) return 0;
  return Number(num.toFixed(digits));
};

/**
 * 格式化日期为月/日格式
 * @param date 日期对象或日期字符串
 * @returns 格式化后的字符串，如 "10/15"
 */
export const formatMonthDay = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  const month = d.getMonth() + 1;
  const day = d.getDate();
  return `${month}/${day}`;
};

/**
 * 生成指定天数的时间标签数组
 * @param days 天数，默认为7天
 * @returns 格式化后的日期标签数组，如 ["10/9", "10/10", "10/11", ...]
 */
export const generateDateLabels = (days: number = 7): string[] => {
  const now = new Date();
  const labels: string[] = [];
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(now);
    d.setDate(now.getDate() - i);
    labels.push(formatMonthDay(d));
  }
  return labels;
};
